import logger from "./logger";
/**
 * WebSocket Test Utility
 * Use this in browser console to verify WebSocket is working
 */

window.testBookingWebSocket = (bookingId, newStatus = "CHECKED_IN") => {
  logger.log("🧪 Testing WebSocket for booking ID:", bookingId);
  logger.log("🧪 Expected status change: PENDING →", newStatus);
  logger.log("");
  logger.log("⚠️ NOTE: Client cannot send WebSocket messages.");
  logger.log("📝 To test properly:");
  logger.log("   1. Use Postman/Backend to change booking", bookingId, "status");
  logger.log("   2. Watch console for 🔴 messages");
  logger.log("   3. UI should update automatically");
  logger.log("");
  logger.log("🔍 Current WebSocket subscriptions:");
  logger.log("   - /topic/organizations/{orgId}/bookings");
  logger.log("   - /user/queue/bookings");
};

logger.log("🧪 WebSocket Test Utility Loaded!");
logger.log("Usage: testBookingWebSocket(607)");
